export const activityState = (state = {}, action) => {
  if (action.type === 'UPDATE_ACTIVITY') {
    const newState = { ...state, ...action.activityState };

    return newState;
  }

  return state;
};
